<script lang="ts" setup>
import { EffectFade, Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import Pagination2 from '@/components/Slider/Pagination2.vue'
import Link1 from '@/components/Button/Link1.vue'
import type { Product } from '@/utils/types'

const props = defineProps({
  products: {
    type: Array<Product>,
    default: []
  },
  url: {
    type: String,
    default: ''
  }
})

SwiperCore.use([Autoplay, Pagination])

const currentIndex: Ref<number> = ref(0)

const swiperSlideSelector = ref()
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data
}

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index)
}

const handelSwiperChange = (data: any) => {
  currentIndex.value = data.realIndex
  // swiperSlideSecondSelector.value.slideTo(data.realIndex)
}

const handleSlidePrev = () => {
  swiperSlideSelector.value.slidePrev()
}
const handleSlideNext = () => {
  swiperSlideSelector.value.slideNext()
}

const handlePaginationChange = (index: number) => {
  swiperTo(index)
  currentIndex.value = index
}

const productList = computed(() => props.products.map((product) => ({
  image: product.image,
  title: product.name,
  url: product.url
})))
</script>

<template>
  <div class="slide">
    <swiper :autoplay="{
      delay: 3000
    }" :slides-per-view="1" :space-between="0" :speed="300" :loop="true" :modules="[EffectFade]" effect="fade"
      class="swiper-list brand-slide-swiper" @swiper="onSwiper" @slide-change="handelSwiperChange">
      <swiper-slide v-for="(item, index) in productList" :key="index">
        <div class="swiper-list__box">
          <figure class="swiper-list__pic square__pic">
            <Nimg :src="item.image?.link" :alt="item.image?.alt" :title="item.image?.title" />
          </figure>
          <div class="swiper-list__right">
            <div class="swiper-list__subtitle">使用的產品</div>
            <div class="swiper-list__title">{{ item.title }}</div>
            <Link1 :to="item.url" class="swiper-list__link" color="gray-3">了解更多</Link1>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="slide__function">
      <div class="pagination-box" v-if="productList.length > 1">
        <Pagination2 :currentIndex="currentIndex" @update:change="handlePaginationChange" :totalIndex="products.length"
          class="pagination-box__item" />
      </div>
      <div class="slide__arrow" v-if="productList.length > 1">
        <div class="arrow brand4-1">
          <div class="arrow__prev" @click="handleSlidePrev">
            <svg-icon name="icon-arrow-right2" />
          </div>
          <div class="arrow__next" @click="handleSlideNext">
            <svg-icon name="icon-arrow-right2" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.swiper-slide {
  opacity: 0 !important;
}

.swiper-slide-active {
  opacity: 1 !important;
}

.slide {
  position: relative;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__function {
    width: 36%;
    height: toRem(65);
    margin-top: toRem(70);

    @include max-media(640) {
      position: relative;
      z-index: 3;
      width: 100%;
      // margin-top: toRem(-185);
      margin-top: toRem(0);
      transform: translateY(-200px);
    }
  }

  &__arrow {
    display: flex;
    justify-content: flex-start;

    .arrow {
      margin-top: toRem(12);
    }
  }
}

.swiper-list {
  &__box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    @include max-media(640) {
      position: relative;
      flex-direction: column-reverse;
      padding-bottom: toRem(224);
    }
  }

  &__pic {
    width: 36%;
    padding-top: 36%;

    @include max-media(640) {
      width: 100%;
      padding-top: 100%;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 48%;
    padding-left: toRem(24);

    @include max-media(767) {
      width: 56%;
    }

    @include max-media(640) {
      width: 100%;
      padding-left: 0;
      margin-bottom: toRem(24);
    }
  }

  &__subtitle {
    display: inline-block;
    margin-bottom: toRem(12);
    padding: toRem(8) toRem(24);
    background-color: $color-brand-4_1;
    font-size: toRem(16);
    font-weight: 700;
    line-height: 1.6;
    color: $color-white-1;
  }

  &__title {
    margin-bottom: toRem(85);
    font-size: toRem(28);
    font-weight: 500;
    line-height: 1.3;

    @include max-media(640) {
      margin-bottom: 0;
    }
  }

  &__link {
    transform: translateY(-12px);

    @include max-media(640) {
      position: absolute !important;
      left: 0;
      bottom: 0;
      transform: translateY(0);
    }
  }
}
</style>
